import * as React from "react";
import { ApolloProvider, type ApolloClient, type NormalizedCacheObject } from "@apollo/client";

import getDisplayName from "common/utils/getDisplayName";
import history from "common/utils/history";
import { staffClient } from "common/data/graphql/client";
import { FiltersProvider } from "@jsq/ds/refilterable";

/**
 * A higher order component that provides access to Apollo client and FiltersProvider
 * Use it only for pillars – don't wrap containers with this HOC
 */
export default function withDataProvider<T extends Record<string, unknown>>(
  WrappedComponent: React.ComponentType<T>,
  graphqlClient: ApolloClient<NormalizedCacheObject> = staffClient,
) {
  function WithDataProvider(props: T) {
    return (
      <FiltersProvider history={history}>
        <ApolloProvider client={graphqlClient}>
          <WrappedComponent {...props} />
        </ApolloProvider>
      </FiltersProvider>
    );
  }

  WithDataProvider.displayName = `withDataProvider(${getDisplayName(WrappedComponent)})`;
  WithDataProvider.defaultProps = { ...WrappedComponent.defaultProps };

  return WithDataProvider;
}
